<!-- <p class="mat-typography mt-3 mb-2 text-center text-lg" *ngIf="!bankSelected" style="transform: translateY(9px);">Select a bank</p>

  <span *ngIf="accountSelection" id="virtual__secure__eft__account__selection__custom">
    <p class="mat-typography text-lg flex font-semibold w-full justify-center mt-3" >Select Account</p>

    <div class="mat-typography account-selection-container">
      <div class="flex flex-wrap justify-center">
        <div class="w-11/12 md:w-1/2 flex justify-center" *ngFor="let option of options" [id]="option.value">
          <div class="card-panel account-selection teal flex justify-center items-center w-9/10 bg-white" (mouseenter)="hover($event, 'enter')" (mouseleave)="hover($event, 'leave')" style="border-radius: 12px; padding: 24px; background-color: white !important;" (click)="selectAccount($event)">
            <span class="text-lg text-black font-semibold">{{ option.text }}</span>
          </div>
        </div>
      </div>
    </div>
  </span> -->

  <!-- <div class="mat-typography modal-body">
    <div class="mat-typography eftx-loader" *ngIf="loading">
        <div class="mat-typography container">
          <mat-spinner
            class="loading-spinner"
            [color]="color"
            [diameter]="diameter"
          >
          </mat-spinner>
        </div>
    </div>
    <form class="" id="eftx-form" autocomplete="false"></form>
    <div class="" id="eftx-button-container" *ngIf="bankSelected"></div>
    <div class="mat-typography clearfix"></div>
    <span class="mat-typography flex justify-center mt-4 text-center" [ngClass]="mobile ? 'flex-col-reverse' : 'flex-row'">Time remaining: {{ uxFriendlyTime(timeRemaining) }}</span>

  </div> -->
<!--  <div class="eft modal" id="eftxModal" tabindex="-1" role="dialog" aria-labelledby="title">-->
<!--    <div class="modal-dialog" role="document">-->
<!--        <div class="modal-content">-->
<!--            <div class="modal-header">-->
<!--                &lt;!&ndash; <h4 class="modal-title pull-left" id="eftx-title">Initialising Transaction</h4>-->
<!--                <h4 class="modal-title pull-right">Amount: R15.00</h4>-->
<!--                <div class="clearfix"></div>-->
<!--                <div>Merchant: AdumoOnline FNB)</div> &ndash;&gt;-->
<!--            </div>-->
<!--            <div class="modal-body">-->
<!--                <h4 id="eftx-subtitle"></h4>-->
<!--                <div class="eftx-loader">-->
<!--                    <div class="container">-->
<!--                        <div class="loader">-->
<!--                            <div class="loader&#45;&#45;dot"></div>-->
<!--                            <div class="loader&#45;&#45;dot"></div>-->
<!--                            <div class="loader&#45;&#45;dot"></div>-->
<!--                            <div class="loader&#45;&#45;dot"></div>-->
<!--                            <div class="loader&#45;&#45;dot"></div>-->
<!--                            <div class="loader&#45;&#45;dot"></div>-->
<!--                            <div class="loader&#45;&#45;text"></div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <form id="eftx-form" class="flex flex-wrap justify-center" autocomplete="false"></form>-->
<!--                <div class="clearfix"></div>-->
<!--            </div>-->
<!--            <div class="modal-footer flex justify-center items-center mt-4" id="eftx-button-container">-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--  </div>-->

<form id="#payment-form" action="/checkout?confirm=1" class="p-4 mt-6">
  <div class="text-center flex justify-center items-center flex-col">
<!--    data-payment-key="{{paymentKey}}"-->
<!--     !!! data-notify-rurl -->
    <div class="flex justify-center items-center flex-col" [style.display]="popupOpened || reopenPopup ? 'none' : ''" [class.cdk-visually-hidden]="popupOpened || reopenPopup" [hidden]="popupOpened || reopenPopup">
      <p class="text-lg mb-4">Popup will open in {{ popupWindowTime }} seconds...</p>
      <mat-spinner
        class="loading-spinner"
        [color]="color"
        [diameter]="diameter"
      >
      </mat-spinner>
      <button id="pay-button" hidden class="btn btn-primary btn-sx p-4 rounded-md shadow-md text-lg bg-white w-1/4 hidden" #payButton type="button">Continue Transaction</button>
    </div>
    <div *ngIf="popupOpened || reopenPopup">
      <div class="flex justify-center items-center flex-col" [style.display]="popupOpened && !reopenPopup ? 'none' : ''" [class.cdk-visually-hidden]="!popupOpened && reopenPopup" [hidden]="!popupOpened && reopenPopup">
        <p class="mat-typography text-lg mb-4">Please continue your transaction</p>
        <span class="mat-typography flex justify-center mt-4 text-center text-lg mb-4" [ngClass]="mobile ? 'flex-col-reverse' : 'flex-row'">Time remaining: {{ uxFriendlyTime(timeRemaining) }}</span>
        <mat-spinner
          class="loading-spinner"
          [color]="color"
          [diameter]="diameter"
        >
        </mat-spinner>
      </div>
      <div class="flex justify-center items-center flex-col" [style.display]="popupOpened && !reopenPopup ? 'none' : ''" [class.cdk-visually-hidden]="popupOpened && !reopenPopup" [hidden]="popupOpened && !reopenPopup">
        <p class="mat-typography text-lg mb-4">Please continue your transaction</p>
        <button mat-raised-button class="btn btn-primary btn-sx p-4 rounded-md shadow-md text-lg bg-white w-1/4" [ngStyle]="{'height': '48px', 'color': 'black',  'border': '3px solid ' + themeColour }" #payButton2 (click)="initPopup()" mat-button type="button">Reopen popup</button>
        <span class="mat-typography flex justify-center mt-4 text-center text-lg mb-4" [ngClass]="mobile ? 'flex-col-reverse' : 'flex-row'">Time remaining: {{ uxFriendlyTime(timeRemaining) }}</span>
        <mat-spinner
          class="loading-spinner"
          [color]="color"
          [diameter]="diameter"
        >
        </mat-spinner>
      </div>
    </div>
  </div>
</form>
